<template>
  <easy-page-template
      title="どの辞書の管理を行いますか？"
      subtitle="管理する辞書を以下の中から選んで下さい。"
      :image="imageTradeContract">
    <template #buttons>
      <easy-nav
          :icon="iconSystemDictionaryLocal"
          title="個別辞書を管理する"
          to="/edit/local/dictionary"
          block>
      </easy-nav>
      <easy-nav
          :icon="iconSystemDictionaryExternal"
          title="外部辞書を管理する"
          to="/edit/external/dictionary"
          block>
      </easy-nav>
    </template>
  </easy-page-template>
</template>

<script>
import EasyPageTemplate from "@/components/pages/easy/EasyPageTemplate.vue";
import iconSystemDictionaryLocal from "./assets/icon_system_dictionary_local.svg";
import iconSystemDictionaryExternal from "./assets/icon_system_dictionary_external.svg";
import imageTradeContract from "./assets/image_trade_contract.svg";
import EasyNav from "@/components/pages/easy/EasyNav.vue";

export default {
  name: "DictionaryManagement",
  components: {EasyNav, EasyPageTemplate},
  data() {
    return {
      iconSystemDictionaryLocal,
      iconSystemDictionaryExternal,
      imageTradeContract,
    }
  },
}
</script>

<style scoped>

</style>
